import { clsx } from 'clsx'
import React, { type PropsWithChildren } from 'react'

type ContainerProps = PropsWithChildren<{
  className?: string
}> &
  React.JSX.IntrinsicElements['div']

export const Container: React.FC<ContainerProps> = ({
  children,
  className,
  ...rest
}) => (
  <div
    className={clsx(
      `container max-w-none laptopL:max-w-screen-laptopL`,
      className
    )}
    {...rest}
  >
    {children}
  </div>
)
